module.exports = __webpack_public_path__ + "static/media/ug.1c8fcdc4.svg";